import { Box, Container, Grid } from "@mui/material";
import Paper from "../../modules/components/Paper";
import React from "react";
import Typography from "../../modules/components/Typography";
import Button from "../../modules/components/Button";
import footerVenmo from "../../modules/components/img/footerVenmo.png";
import footerPaypal from "../../modules/components/img/footerPaypal.png";

const iconStyle = {
  width: 48,
  height: 48,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'warning.main',
  mr: 1,
  '&:hover': {
    bgcolor: 'warning.dark',
  },
};

export default function Donate() {
  return (
    <Container maxWidth="sm" sx={{ flexGrow: 1, p: 2 }}>
      <Box sx={{ mt: 2, mb: 4 }}>
        <Paper
          background="light"
          sx={{ py: { xs: 4, md: 8 }, px: { xs: 3, md: 6 } }}
        >
          <Typography variant="h3" gutterBottom marked="center" align="center" pb={4}>
            Donate
          </Typography>
          <Typography variant="body2" align="center">
            If you have found this app useful, please consider supporting it by leaving a donation.
            This will help to cover the costs of operating and maintaining the site!
          </Typography>
          <Grid container justifyContent='center' columnGap={2} sx={{ p: 2, pb: 4 }}>
            <Box component="a" target="_blank" href="https://www.paypal.me/WatchExchanger" sx={iconStyle}>
              <img
                src={footerPaypal}
                alt="Paypal"
                width="65%"
              />
            </Box>
            <Box component="a" target="_blank" href="https://www.venmo.com/WatchExchanger" sx={iconStyle}>
              <img
                src={footerVenmo}
                alt="Venmo"
                width="140%"
              />
            </Box>
          </Grid>
          <Typography variant="body2" align="center">
            But the best way to support the site is by upgrading your account! Plus, you'll gain even more features.
          </Typography>
          <Box sx={{ m: 2 }}>
            <Button 
              variant="contained"
              fullWidth
              href='/dashboard/upgrade'
            >
              Learn more about upgrading
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}